import React, { useState, useEffect } from 'react';
import { 
    Header, ImageHeader, ContentOne, ContentTwo, ContentThree, Carrusel, ContentFour, ContentFive, PregFrec, Footer
} from './components';

import '../../styles/pages/soymas.css';

import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export default function Pager() {
    const [loading, setLoading] = useState(true);

  // Simulamos la carga de datos (2 segundos)
    useEffect(() => {
        window.scrollTo(0, 0);

        const timer = setTimeout(() => {
        setLoading(false);
        }, 100);
        return () => clearTimeout(timer);
        
    }, []);

    if (loading) {
        return (
        <div style={{ padding: '20px' }}>
            <Skeleton height={70} style={{ marginBottom: '20px' }} />
            <Skeleton height={250} style={{ marginBottom: '20px' }} />
            <Skeleton count={1} height={50} style={{ marginBottom: '10px' }} />
            <Skeleton count={2} height={80} style={{ marginBottom: '10px' }} />
            <Skeleton count={3} height={100} style={{ marginBottom: '10px' }} />
            <Skeleton height={150} style={{ marginBottom: '20px' }} />
            <Skeleton count={2} height={80} style={{ marginBottom: '10px' }} />
            <Skeleton count={2} height={80} style={{ marginBottom: '10px' }} />
            <Skeleton count={1} height={100} style={{ marginBottom: '20px' }} />
            <Skeleton height={70} />
        </div>
        );
    }

    return (
        <>
        <Header />
        <ImageHeader />
        <ContentOne />
        <ContentTwo />
        <ContentThree />
        <Carrusel />
        <ContentFour />
        <ContentFive />
        <PregFrec />
        <Footer />
        </>
    );
}
